/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Shot_Demo_NoteInputs */

const en_mk_shot_demo_note = /** @type {(inputs: Mk_Shot_Demo_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actual product screens with example data from Dapur Nusa. Select any screenshot to explore it.`)
};

const id_mk_shot_demo_note = /** @type {(inputs: Mk_Shot_Demo_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tampilan produk asli dengan data contoh Dapur Nusa. Pilih screenshot untuk melihat lebih dekat.`)
};

/**
* | output |
* | --- |
* | "Actual product screens with example data from Dapur Nusa. Select any screenshot to explore it." |
*
* @param {Mk_Shot_Demo_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_shot_demo_note = /** @type {((inputs?: Mk_Shot_Demo_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Shot_Demo_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_shot_demo_note(inputs)
	return en_mk_shot_demo_note(inputs)
});